import language from '../config/language';
import resolvePath from '../utils/dottify';

export function translate(lang, transl = language || {}) {
  const get = resolvePath(lang);

  return get(transl);
}

export function applyLang(el, lang, transl) {
  const value = translate(lang, transl);

  if (value) el.innerHTML = value;
}

export default (trl = language) => trl && forEach(document.querySelectorAll('[data-lang]'), e => {
  applyLang(e, e.dataset.lang, trl);
});

const forEach = (lst, cb) => {
  for (let i = 0; i < lst.length; i++) cb(lst[i], i);
};
